module.exports = __webpack_public_path__ + "static/img/header-logo.455b8a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-logo.png
// module id = jap3
// module chunks = 5